import { createSlice } from "@reduxjs/toolkit";
import { applicationSessionChanged } from "./GlobalActions";
import type { RootState } from "../Store";

const initialState: { identityKey: string | null; epoch: number } = { identityKey: null, epoch: 0 };
const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(applicationSessionChanged, (state, action) => {
      if (state.identityKey !== action.payload.identityKey) {
        state.identityKey = action.payload.identityKey;
        state.epoch += 1;
      }
    }),
});

export const applicationSessionReducer = sessionSlice.reducer;
export const selectApplicationSessionEpoch = (state: RootState): number => state.session?.epoch ?? 0;
